import styled from "styled-components";

export default styled.div`
  span {
    font-size: 14px;
  }

  background-color: ${(props) => props.theme.colors.primary.aqua};
  color: ${(props) => props.theme.colors.primary.contrast};
  padding: 12px;
  display: flex;
  align-contents: center;

  .aisearch--toggle {
    margin: 0px;
    gap: 8px;
    color: ${(props) => props.theme.colors.primary.contrast};
  }

  .aisearch--toggle > span {
    width: max-content;
  }

  .switch--button {
    span {
      span {
        span {
          input {
            display: contents;
          }
        }
      }
    }
  }

  .switch {
    border: 2px solid white;
    border-radius: 24px;
    padding: 0px;
    background-color: ${(props) => props.theme.colors.primary.aqua};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 24px;

    .MuiButtonBase-root {
      padding: 2.25px 2px 2px 3.5px;
      .MuiIconButton-label {
        .MuiSwitch-thumb {
          height: 16px;
          width: 16px;
          box-shadow: none;
        }
      }
    }
    .Mui-checked {
      transform: translateX(24px);
      color: ${(props) => props.theme.colors.primary.contrast};
      background-color: ${(props) => props.theme.colors.primary.aqua};
    }
    .MuiSwitch-track {
      background-color: transparent;
      opacity: 100% !important;
    }

    .MuiSwitch-track::before,
    .MuiSwitch-track::after {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      font-size: 8px;
      color: ${(props) => props.theme.colors.primary.contrast};
      letter-spacing: 0.5px;
      line-height: 10.55px;
      font-weight: 700;
    }
  }

  .toggle-on {
    .MuiSwitch-track::before {
      left: 6px;
      content: "ON";
    }
  }

  .toggle-off {
    .MuiSwitch-track::after {
      right: 5px;
      content: "OFF";
    }
  }
`;
